import { Box } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";

import { Virtuoso } from "react-virtuoso";
import { ChatComponent } from "./ChatComponent";

export const MessagesList = ({
  messages,
  startReached,
  virtuoso,
  startIndex,
}) => {
  const [firstItemIndex, setFirstItemIndex] = useState(
    startIndex - messages.length
  );

  const internalMessages = useMemo(() => {
    const nextFirstItemIndex = startIndex - messages.length;
    setFirstItemIndex(nextFirstItemIndex);
    return messages;
  }, [messages, startIndex]);

  const itemContent = useCallback((index, rowData) => {
    const userName = rowData?.userName ?? "FC";
    const message = rowData?.comment;
    const type = rowData?.userType ?? "FC";
    const createdDate = rowData?.createdDate;
    const withAttachment = rowData?.is_attachment;
    return (
      <Box>
        <ChatComponent
          userName={userName}
          message={message}
          type={type}
          createdDate={createdDate}
          withAttachment={withAttachment === "true"}
        />
      </Box>
    );
  }, []);

  const followOutput = useCallback((isAtBottom) => {
    return isAtBottom ? "smooth" : "auto";
  }, []);

  const List = React.forwardRef((props, ref) => {
    return <Box sx={{ pl: 3, pr: 4 }} {...props} ref={ref}></Box>;
  });

  return (
    <>
      <Virtuoso
        ref={virtuoso}
        totalCount={startIndex}
        initialTopMostItemIndex={internalMessages.length - 1}
        firstItemIndex={Math.max(0, firstItemIndex)}
        itemContent={itemContent}
        components={{
          Footer: () => <Box height={60}> </Box>,
          Header: () => <Box height={20}> </Box>,
          List: List,
        }}
        data={internalMessages}
        startReached={startReached}
        followOutput={followOutput}
        style={{ height: "400px" }}
        className="tableScroll"
      />
    </>
  );
};
